import { render, staticRenderFns } from "./CRUD.vue?vue&type=template&id=6cee2e9e&scoped=true&"
import script from "./CRUD.vue?vue&type=script&lang=ts&"
export * from "./CRUD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cee2e9e",
  null
  
)

export default component.exports